/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester*/
import React from 'react';
import PropTypes from 'prop-types';
import * as mainStyles from '../../../styles/layout/main.module.scss';

const BottomLayout = ({ children }) => {

  return (
    <div className={mainStyles.bottomTemplate}>
      {children}
    </div>
  );
};

BottomLayout.propTypes = {
  children: PropTypes.node,
};

export default BottomLayout;
